<div id="i3-tc-container" (click)="onCardClick()" [ngClass]="{'is-selected': isSelected, 'is-status': itemType == I3TableItemType.OperatingStatus}">
    <div id="i3-ico-lbl" class="prevent-select" [ngStyle]="{'font-size': fontSizePx + 'px'}">
        <fa-icon *ngIf="itemType != I3TableItemType.OperatingStatus" icon="circle"
                 [ngClass]="{'i3-blue': itemType == I3TableItemType.WorkOrder, 'i3-red': itemType == I3TableItemType.AssetDown, 'i3-orange': itemType == I3TableItemType.MaintenanceDueAsset}"
        ></fa-icon>
        <fa-icon *ngIf="itemType == I3TableItemType.OperatingStatus" icon="circle"
                 [ngStyle]="{'color': opStatusColor}"
        ></fa-icon>

        <div id="i3-lbl-container">
            <div *ngIf="itemType == I3TableItemType.AssetDown" id="i3-lbl-wrapper">{{ asset['assetCode'] }}</div>
            <div *ngIf="itemType == I3TableItemType.MaintenanceDueAsset || itemType == I3TableItemType.WorkOrder" id="i3-lbl-wrapper">{{ asset['assetId'] }}</div>
            <div *ngIf="itemType == I3TableItemType.OperatingStatus" id="i3-lbl-wrapper">
                <div>{{ asset['assetCode'] }}</div>
            </div>
        </div>
    </div>

    <div id="i3-op-status-container" class="prevent-select" *ngIf="itemType == I3TableItemType.OperatingStatus">
        <div id="i3-operating-status">{{ this.operationStatus | translate }}</div>
        <div class="prevent-select"><img id="i3-link-ico" src="../../../../../../assets/images/intelli360/i3-site-link-dark.png" alt=""></div>
    </div>

    <div *ngIf="itemType != I3TableItemType.OperatingStatus" class="prevent-select"><fa-icon icon="chevron-right"></fa-icon></div>
</div>
